import React from 'react';
import { motion } from 'framer-motion';

const AnimatedSection = ({ children, className, ...props }) => {
    const sectionVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                staggerChildren: 0.2
            }
        }
    };

    return (
        <motion.section
            className={className}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={sectionVariants}
            {...props}
        >
            {children}
        </motion.section>
    );
};

export default AnimatedSection;